<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>欠款客户清单</span>
      </div>
    </div>
    <finance-seach :column-option="havetabs" @onSearch="onSearch"></finance-seach>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        :data="list"
        :max-height="$store.state.Sell.heightTitle"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column fixed label="客户名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onCusName(scope.row)"
            >{{scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="cusCode" label="客户编号"></el-table-column>
        <el-table-column label="贸易总额" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.contractTotal | priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="应收账款" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.accountsReceivable | priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已到期账款" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.accountsDue | priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="已收账款" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.paymentReceived | priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="坏账" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.badDebt | priceFilterNum}}</template>
        </el-table-column>
        <el-table-column prop="number" label="待划拨合同数" width="106"></el-table-column>
        <el-table-column prop="ccContacts" label="联系人"></el-table-column>
        <el-table-column label="电话" prop="ccPhone" show-overflow-tooltip></el-table-column>
        <el-table-column label="手机" prop="ccMobile"></el-table-column>
        <el-table-column label="欠款起始日" width="92">
          <template slot-scope="scope">{{ scope.row.dueDate | dateFilterD }}</template>
        </el-table-column>
        <el-table-column prop="staffCnName" label="当前负责人"></el-table-column>
        <el-table-column prop="orgName" label="所属部门" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { havetabs } from '../financeManage/util/data'
import { queryTransFlowByOcbId } from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
export default {
  components: {
    pagination,
    financeSeach
  },
  data () {
    return {
      columnArr: [],
      havetabs, // 筛选条件
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onSearch (arr) {
      // 搜索
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = arr
      this.getList()
    },
    onCusName (row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
      // this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      this.loadingTable = false
      const params = {
        criteriaVoList: this.columnArr,
        queryPageName: ''
      }
      queryTransFlowByOcbId(0, this.currentPage, this.pageSize, params).then(
        (res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          } else {
            this.$message.error(res.data.msg)
          }
        }
      )
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
